export default {
    import: "ส่งออกไฟล์",
    peopleBook: "จำนวนคนที่จองคิว",
    booked: "จำนวนครั้งที่จองคิว",
    clickHere: "คลิกที่นี่เพื่อดูรายละเอียด",
    updated: "อัปเดตการนัดหมาย",
    btn: {
        creat: "สร้างโต๊ะ",
        creatFund: "สร้างทุน",
        pagination: "จำนวนแสดงผล",
    },
    tapList: {
        total: "ทั้งหมด",
        active: "เปิดรับ",
        inactive: "ปิดรับ",
        pending: "รออนุมัติ",
        reject: "ปฏิเสธ",
        draft: "ฉบับร่าง",
    },
    tapManage: {
        all: "ผู้สมัครทั้งหมด",
        waiting: "รอสัมภาษณ์",
        rejectbook: "ปฏิเสธนัดสัมภาษณ์",
        pending: "รอปรับสถานะ",
        passed: "ผ่านสัมภาษณ์ ",
        notPass: "ไม่ผ่านสัมภาษณ์",
        missed: "ขาดสัมภาษณ์",
    },
    tapManage_consult: {
        all: "ผู้สมัครทั้งหมด",
        waiting: "รอให้คำปรึกษา",
        rejectbook: "ปฏิเสธการให้คำปรึกษา",
        pending: "รอปรับสถานะ",
        passed: "ให้คำปรึกษาเสร็จสิ้น ",
        notPass: "ไม่ผ่านสัมภาษณ์",
        missed: "ไม่มาขอคำปรึกษา",
    },
    header: {
        updatedAt: "วันที่แก้ไขล่าสุด",
        jopPo: "รายละเอียดโต๊ะ",
        jopPoFund: "รายละเอียดทุน",
        appAmount: "จำนวนผู้สมัคร",
        status: "สถานะ",
    },
    amount: {
        all: "ทั้งหมด",
        appAll: "ผู้สมัครทั้งหมด",
        notViewedResume: "ยังไม่เปิดดูประวัติ",

        booking: "การนัดหมาย",
        applyJob: "การสมัครงาน",
    },
}